import React from 'react'
import './PdfFeatures.scss';
import SplitIcon from '../../assets/SplitIcon.png';
import ReorderIcon from '../../assets/ReorderIcon.png';
import MergeIcon from '../../assets/MergeIcon.png';
import RotateIcon from '../../assets/RotateIcon.png';
import DeleteIcon from '../../assets/DeleteIcon.png';

export default function PdfFeatures() {
  return (
    <div className='features-container'>
      <div className='left-section'>
        <h1>The more you organize the less you stress!</h1>
        <p>
          Keep your PDFs organized with ease! Whether you need to split large files, merge multiple PDFs into one, reorder pages, rotate them for better readability, or delete unwanted sections, our powerful tools help you manage everything effortlessly. Say goodbye to cluttered documents and hello to a stress-free workflow!
        </p>
      </div>
      <div className='right-section'>
        <div className='row1'>
          <div className='split-pdf-container'>
            <div className='split-icon-container'>
              <img src={SplitIcon} alt="split pdf" />
            </div>
            <p>Split</p>
            <p>PDF</p>
          </div>
          <div className='order-pdf-container'>
            <div className='order-icon-container'>
              <img src={ReorderIcon} alt="re-order pdf pages" />
            </div>
            <p>Re-order</p>
            <p>Pdf Pages</p>
          </div>
        </div>
        <div className='row2'>
          <div className='merge-pdf-container'>
            <div className='merge-icon-container'>
              <img src={MergeIcon} alt="merge pdf" />
            </div>
            <p>Merge PDF</p>
          </div>
          <div className='rotate-pdf-container'>
            <div className='rotate-icon-container'>
              <img src={RotateIcon} alt="rotate pdf" />
            </div>
            <p>Rotate Pdf</p>
          </div>
          <div className='delete-pdf-container'>
            <div className='delete-icon-container'>
              <img src={DeleteIcon} alt="delete pdf" />
            </div>
            <p>Delete Pdf</p>
          </div>
        </div>
      </div>
    </div>
  )
}
